const fromAnyToTrimmed = any => (any === null || undefined === any ? '' : String(any)).trim();

// noinspection JSUnusedGlobalSymbols
export default fromAnyToTrimmed;
